import { render, staticRenderFns } from "./VacationRequestList.vue?vue&type=template&id=63c77958&scoped=true"
import script from "./VacationRequestList.vue?vue&type=script&lang=js"
export * from "./VacationRequestList.vue?vue&type=script&lang=js"
import style0 from "./VacationRequestList.vue?vue&type=style&index=0&id=63c77958&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c77958",
  null
  
)

export default component.exports